import { render, staticRenderFns } from "./RecommendedPlans.vue?vue&type=template&id=12c7d036&scoped=true"
import script from "./RecommendedPlans.vue?vue&type=script&lang=js"
export * from "./RecommendedPlans.vue?vue&type=script&lang=js"
import style0 from "./RecommendedPlans.vue?vue&type=style&index=0&id=12c7d036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c7d036",
  null
  
)

export default component.exports